import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popup from '../../../common/Popup/Popup';
import AppTable from '../../../common/AppTable/AppTable';
import { taskTableColumns } from '../TaskTableColumns';
import AddEditRow from '../AddEditRow';
import { fetchTasksWithCustomQuery } from '../../../redux/taskSlice';
import { fetchUsers } from '../../../redux/userSlice';
import { showSnackbar } from '../../../redux/snackbarSlice';
import { Button } from '../../../common/Buttons';
import Loader from '../../../common/Loader';
import FilterDropdown from '../../../common/AppSpecificConpnents/PartsTable/FilterDropdown';
import { handleUpdateTask, handleDeleteTask, isTerminalTaskStatus } from '../Uitlities';
import { getLoggedInUserInfo } from '../../../util/AppUtils';
import TaskUpdateConfirm from './TaskUpdateConfirm';

const OpenTasksPopup = ({ closeModal, procedure_ltree_ref, onContinue, isContinueDisabled = false, title }) => {
  const dispatch = useDispatch();
  const { tasks, loading, taskReference } = useSelector((state) => state.task);
  const { users } = useSelector((state) => state.users);
  const { task_reference } = taskReference || {};
  const reassign_persmision = getLoggedInUserInfo()?.permission_to_edit?.Reassign === true;
  const { pendingCount } = useSelector((state) => state.task);

  const [editTask, setEditTask] = useState(null);
  const [previusTaskInfo, setPreviusTaskInfo] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [isChecking, setIsChecking] = useState(true);

  const filterOptions = [
    { value: "all", label: "Open Tasks" }
  ];

  useEffect(() => {
    const fetchData = async () => {
      let query = searchQuery;
      if (procedure_ltree_ref) {
        if (searchQuery.length) {
          // Build query with procedure_ltree_ref and search query
          if (!query.includes("procedure_ltree_ref=")) {
            query += `&procedure_ltree_ref=${procedure_ltree_ref}`;
          }
          localStorage.setItem("openTasksQuery", query);
        } else {
          // Initial load without search
          query = `procedure_ltree_ref=${procedure_ltree_ref}`;
          localStorage.setItem("openTasksQuery", query);
        }

        if (isChecking) {
          try {
            const result = await dispatch(fetchTasksWithCustomQuery({ queryParams: query, pagination: false })).unwrap();
            const resultTasks = result.results || result || [];
            const openTasksCount = Array.isArray(resultTasks)
              ? resultTasks.filter(task => task.status !== "COMPLETED" && task.status !== "CANCELLED").length
              : 0;

            if (openTasksCount === 0) {
              if (onContinue) onContinue();
              closeModal(false);
            } else {
              setIsChecking(false);
            }
          } catch (error) {
            console.error("Error fetching tasks:", error);
            setIsChecking(false); // Show popup on error
          }
        } else {
          dispatch(fetchTasksWithCustomQuery({ queryParams: query, pagination: false }));
        }
      }
    }

    fetchData();
  }, [dispatch, procedure_ltree_ref, searchQuery]);

  useEffect(() => {
    dispatch(fetchUsers({ limit: 100000, offset: 0 }));
  }, [dispatch]);

  const snackbar = (message, type) => {
    dispatch(showSnackbar({ type: type, message: message }));
  };

  const onSuccess = async () => {
    await dispatch(fetchTasksWithCustomQuery({ queryParams: localStorage.getItem("openTasksQuery"), pagination: false }));
  }

  const proceedWithUpdate = async () => {
    await handleUpdateTask({
      editTask,
      previusTaskInfo,
      reassign_persmision,
      users,
      dispatch,
      snackbar,
      onSuccess: async () => {
        await onSuccess();
        setShowConfirmPopup(false);
      },
      setEditTask
    });
  };

  const updateTaskInfo = async () => {
    const newStatus = editTask?.status;
    const previousStatus = previusTaskInfo?.status;

    if (
      newStatus !== previousStatus &&
      isTerminalTaskStatus(newStatus) &&
      !isTerminalTaskStatus(previousStatus)
    ) {
      setShowConfirmPopup(true);
      return;
    }

    await proceedWithUpdate();
  };

  const delTask = async (task_id, task_name) => {
    await handleDeleteTask({
      task_id,
      task_name,
      dispatch,
      snackbar,
      onSuccess: onSuccess,
      setEditTask
    });
  };

  const getLoadingMessage = () => {
    if (editTask) return "Updating task...";
    return "Loading tasks...";
  };

  const columns = taskTableColumns.map(d => ({ ...d, sort: false }));
  const allTasks = Array.isArray(tasks)
    ? tasks.filter(task => task.status !== "COMPLETED" && task.status !== "CANCELLED")
    : [];


  return isChecking ? <Loader /> : (<>
    <Popup
      closeModal={closeModal} title={<>
        <div style={{ padding: "0px", lineheight: "8px !important" }}>
          <p style={{ margin: "0px", fontSize: "20px", color: "#0D6EFD", fontWeight: "bold" }}>{title || "Pending tasks for the node"}</p>
          <p style={{ fontSize: "12px", color: "black", margin: "0px", fontWeight: "normal" }}>
            
            {isContinueDisabled ? "Before you proceed, you must mark the open tasks as COMPLETED or CANCELLED" : "Please review the open tasks for the selection before proceeding"}
          </p>
        </div>
      </>}
      headerStyle={{ borderBottom: '1px solid #e0e0e0' }}
    >
      <div>
        {/* Table */}
        {/* {loading && <Loader text={getLoadingMessage()} />} */}
        <AppTable
          columnsData={columns}
          showSearchInput={true}
          usingInPopup={true}
          paginate={false}
          showScroll={true}
          contentBeforeSearchFilter={
            <FilterDropdown
              filterOptions={filterOptions}
              filterType={filterType}
              setFilterType={setFilterType}
              disableFilter={true}
              usingInPopup={true}
            />
          }
          onFilterSortHandler={setSearchQuery}
        >
          {allTasks.map((task) => {
            let key = task.task_id;
            return editTask && editTask.task_id === task.task_id ? (
              <AddEditRow
                key={key}
                taskInfo={task}
                handleAddEditRow={updateTaskInfo}
                inputState={setEditTask}
                action="edit"
                reference={task_reference}
                closePopup={closeModal}
                setPreviusTaskInfo={setPreviusTaskInfo}
                reassign_persmision={reassign_persmision}
              />
            ) : (
              <AddEditRow
                key={key}
                taskInfo={task}
                inputState={setEditTask}
                delTask={delTask}
                setPreviusTaskInfo={setPreviusTaskInfo}
                reference={task_reference}
                closePopup={closeModal}
                reassign_persmision={reassign_persmision}
              />
            );
          })}
        </AppTable>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          marginTop: '0px',
          paddingTop: '5px',
          paddingRight: '15px',
          paddingBottom: '15px',
          borderTop: '1px solid #e0e0e0'
        }}>
          <Button
            variant="secondary"
            onClick={() => closeModal(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={isContinueDisabled  && pendingCount > 0}
            onClick={() => {
              if (onContinue) {
                onContinue();
              }
              closeModal(false);
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </Popup>
    {showConfirmPopup && (
      <TaskUpdateConfirm
        closeModal={() => setShowConfirmPopup(false)}
        onSave={proceedWithUpdate}
        status={editTask?.status}
      />
    )}
    </>
  );
};

export default OpenTasksPopup;

